export default __webpack_public_path__ + "static/media/logo_ecat.eb7ca3cc.png";